// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"34":"react-chatbot","328":"ChatBot"}[chunkId] || chunkId) + "." + {"34":"958dd5cb","328":"c50b129f","453":"3b1b0cec","833":"b917ac3e"}[chunkId] + ".chunk.js";
};